import React from 'react';
import { useTranslation } from 'react-i18next';

interface GalleryImage {
  src: string;
  alt: string;
}

const HeroGallery: React.FC = () => {
  const { t } = useTranslation();

  // First carousel - moves left
  const topImages: GalleryImage[] = [
    { src: '/restaurant_photos/oyster.JPG', alt: 'Fresh oysters' },
    { src: '/restaurant_photos/IMG_6898.jpg', alt: 'Fresh fruits' },
    { src: '/restaurant_photos/menu_photo.JPG', alt: 'Delicious buffet' },
  ];

  // Second carousel - moves right
  const bottomImages: GalleryImage[] = [
    { src: '/restaurant_photos/shrimp.JPG', alt: 'Grilled shrimp' },
    { src: '/restaurant_photos/IMG_6902.jpg', alt: 'Dessert selection' },
    { src: '/restaurant_photos/IMG_6900.jpg', alt: 'Premium meats' },
  ];

  return (
    <section className="py-8 md:py-14 lg:py-20 bg-luxury-cream relative">
      {/* Cherry Blossom Decoration Background - Full Page Width */}
      <img 
        src="/restaurant_photos/cherry_blossom2.png"
        alt=""
        className="absolute left-0 top-[20%] -translate-y-1/2 w-[70%] md:w-[55%] lg:w-[45%] h-auto opacity-10 pointer-events-none z-0" style={{ transform: 'translateY(-50%) scaleX(-1) scaleY(-1)' }}
      />
      
      <div className="max-w-full relative z-10">
        <div className="text-center mb-8 md:mb-12 lg:mb-20 section-padding">
          <p className="text-luxury-gold text-lg tracking-luxury uppercase font-body mb-4">
            Ambiance
          </p>
          <h2 className="text-display-md md:text-display-lg font-display mb-6 text-luxury-black">
            {t('gallery.title', 'Découvrez Notre Restaurant')}
          </h2>
          <div className="h-px bg-luxury-gold mx-auto w-20" />
        </div>

        {/* First Carousel - Scrolls Left */}
        <div className="relative mb-8">
          <div className="flex animate-scroll-left-mobile md:animate-scroll-left">
            {/* Double the images for seamless loop */}
            {[...topImages, ...topImages].map((image, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-[400px] h-[300px] mx-4"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover rounded-lg shadow-lg"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Second Carousel - Scrolls Right */}
        <div className="relative">
          <div className="flex animate-scroll-right-mobile md:animate-scroll-right">
            {/* Double the images for seamless loop */}
            {[...bottomImages, ...bottomImages].map((image, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-[400px] h-[300px] mx-4"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover rounded-lg shadow-lg"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8 section-padding">
          <a href="/gallery">
            <button className="luxury-button">
              {t('gallery.viewMore', 'Voir Plus de Photos')}
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroGallery;